
export const removeDuplicated = (arr) => {
    return arr.filter((item, index) => arr.findIndex((obj) => obj === item) === index);
};